var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container potentialSupplierManageDetail" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("supplierManage.basicInfo"), name: "1" } },
            [
              _c(
                "div",
                { staticClass: "searchBox_top" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.historyBack },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.close")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "scrollYBox" },
                [
                  _vm.emplFlag != "SUP" && _vm.groupType == "SUPPLIER"
                    ? _c(
                        "el-card",
                        { staticClass: "box-card" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "clearfix",
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "supplierManage.supplierCategoryInfo"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "el-form",
                            {
                              ref: "CategoryInfoForm",
                              attrs: {
                                model: _vm.CategoryInfoForm,
                                "label-width": "120px",
                              },
                            },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.Category1"
                                        ),
                                        prop: "categoryLevel1Id",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value:
                                              _vm.CategoryInfoForm
                                                .categoryLevel1Id,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.CategoryInfoForm,
                                                "categoryLevel1Id",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "CategoryInfoForm.categoryLevel1Id",
                                          },
                                        },
                                        _vm._l(
                                          _vm.categoryList1,
                                          function (item, index) {
                                            return _c(
                                              "el-checkbox",
                                              {
                                                key: index,
                                                attrs: {
                                                  disabled: "",
                                                  label: item.tmCategoryId,
                                                },
                                              },
                                              [_vm._v(_vm._s(item.name))]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.Category2"
                                        ),
                                        prop: "categoryLevel2Id",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value:
                                              _vm.CategoryInfoForm
                                                .categoryLevel2Id,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.CategoryInfoForm,
                                                "categoryLevel2Id",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "CategoryInfoForm.categoryLevel2Id",
                                          },
                                        },
                                        _vm._l(
                                          _vm.categoryList2,
                                          function (item, index) {
                                            return _c(
                                              "el-checkbox",
                                              {
                                                key: index,
                                                attrs: {
                                                  disabled: "",
                                                  label: item.tmCategoryId,
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "Categorypname",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.pname) + "："
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(_vm._s(item.name)),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "supplierManage.confidentialityAgreement"
                                )
                              )
                            ),
                          ]),
                          _c(
                            "el-tag",
                            {
                              staticStyle: {
                                "margin-left": "20px",
                                "font-size": "15px",
                              },
                              attrs: { type: "danger" },
                            },
                            [
                              _vm._v(
                                "新供应商注册需完成保密协议签署，才能再进行后续的注册信息填写与提交"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          ref: "lawFileList",
                          attrs: {
                            data: _vm.lawFileList,
                            border: "",
                            "highlight-current-row": "",
                            "max-height": "420",
                          },
                        },
                        [
                          _c(
                            "el-table-column",
                            {
                              attrs: {
                                label: _vm.$t("supplierManage.fileName"),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "supplierManage.confidentialityAgreement"
                                  )
                                )
                              ),
                            ]
                          ),
                          _c(
                            "el-table-column",
                            {
                              attrs: {
                                label: _vm.$t("common.file"),
                                prop: "current",
                              },
                            },
                            [
                              [
                                _c(
                                  "el-link",
                                  {
                                    attrs: { type: "primary" },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.downloadTemplate(
                                          "/templates/download/附件二 麦当劳保密协议_CN.PDF",
                                          "附件二 麦当劳保密协议_CN.PDF"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("附件二 麦当劳保密协议_CN.PDF")]
                                ),
                                _c(
                                  "el-link",
                                  {
                                    attrs: { type: "primary" },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.downloadTemplate(
                                          "/templates/download/附件二 麦当劳保密协议_ENCN.PDF",
                                          "附件二 麦当劳保密协议_ENCN.PDF"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("附件二 麦当劳保密协议_ENCN.PDF")]
                                ),
                              ],
                            ],
                            2
                          ),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("common.status"),
                              prop: "statusI18n",
                            },
                          }),
                          _vm.canEdit
                            ? _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("base.linePrice.operation"),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-link",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: scope.row.tmLawFileId,
                                                  expression:
                                                    "scope.row.tmLawFileId",
                                                },
                                              ],
                                              attrs: { type: "primary" },
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.seeLegalFileDetail(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("common.see"))
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2382594149
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("supplierManage.supplierBasicInfo"))
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-form",
                        {
                          ref: "basicInfoForm",
                          attrs: {
                            model: _vm.basicInfoForm,
                            "label-width": "140px",
                          },
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.supplierChinese"
                                        ),
                                        prop: "supplierName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          disabled: "",
                                          maxlength: "60",
                                        },
                                        model: {
                                          value: _vm.basicInfoForm.supplierName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.basicInfoForm,
                                              "supplierName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "basicInfoForm.supplierName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.supplierAbbreviation"
                                        ),
                                        prop: "supplierNameShort",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          disabled: "",
                                          maxlength: "60",
                                        },
                                        model: {
                                          value:
                                            _vm.basicInfoForm.supplierNameShort,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.basicInfoForm,
                                              "supplierNameShort",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "basicInfoForm.supplierNameShort",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.supplierInvitationCode"
                                        ),
                                        prop: "invitationCode",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "", disabled: "" },
                                        model: {
                                          value:
                                            _vm.basicInfoForm.invitationCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.basicInfoForm,
                                              "invitationCode",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "basicInfoForm.invitationCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.supplierEnglish"
                                        ),
                                        prop: "supplierNameEn",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          disabled: "",
                                          maxlength: "100",
                                        },
                                        model: {
                                          value:
                                            _vm.basicInfoForm.supplierNameEn,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.basicInfoForm,
                                              "supplierNameEn",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "basicInfoForm.supplierNameEn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.supplierType"
                                        ),
                                        prop: "groupType",
                                      },
                                    },
                                    [
                                      _c("ic-select", {
                                        attrs: {
                                          clearable: "",
                                          table: "TM_SUPPLIER",
                                          field: "GROUP_TYPE",
                                          disabled: "",
                                        },
                                        model: {
                                          value: _vm.basicInfoForm.groupType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.basicInfoForm,
                                              "groupType",
                                              $$v
                                            )
                                          },
                                          expression: "basicInfoForm.groupType",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.supplierInviter"
                                        ),
                                        prop: "inviter",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "", disabled: "" },
                                        model: {
                                          value: _vm.basicInfoForm.inviter,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.basicInfoForm,
                                              "inviter",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "basicInfoForm.inviter",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.auditStatus"
                                        ),
                                        prop: "auditStatus",
                                      },
                                    },
                                    [
                                      _c("ic-select", {
                                        attrs: {
                                          clearable: "",
                                          table: "TM_SUPPLIER",
                                          field: "AUDIT_STATUS",
                                          disabled: "",
                                        },
                                        model: {
                                          value: _vm.basicInfoForm.auditStatus,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.basicInfoForm,
                                              "auditStatus",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "basicInfoForm.auditStatus",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "supplierManage.socialUniformCreditCode"
                                        ),
                                        prop: "socialUniformCreditCode",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "", disabled: "" },
                                        model: {
                                          value:
                                            _vm.basicInfoForm
                                              .socialUniformCreditCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.basicInfoForm,
                                              "socialUniformCreditCode",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "basicInfoForm.socialUniformCreditCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form",
                        {
                          ref: "formlinkUsers",
                          attrs: { model: _vm.formlinkUsers },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              ref: "linkUsersList",
                              attrs: {
                                data: _vm.formlinkUsers.linkUsersList,
                                border: "",
                                "highlight-current-row": "",
                                "max-height": "420",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "name",
                                  label: _vm.$t(
                                    "supplierManage.supplierContacts"
                                  ),
                                  "min-width": "120",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "tel",
                                  label: _vm.$t("settlementUnit.supplierTel"),
                                  "min-width": "120",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "officeTel",
                                  label: "办公室电话",
                                  "min-width": "120",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "email",
                                  label: "邮箱",
                                  "min-width": "120",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "title",
                                  label: _vm.$t("supplierManage.position"),
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("ic")(
                                                scope.row.title,
                                                "TM_SUPPLIER",
                                                "CONTACT_POSITION"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("supplierManage.supplierAddressInfo")
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-form",
                        {
                          ref: "formAddress",
                          attrs: { model: _vm.formAddress },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              ref: "plantList",
                              staticClass: "addressBox",
                              attrs: {
                                data: _vm.formAddress.plantList,
                                border: "",
                                "highlight-current-row": "",
                                "max-height": "420",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "supplierName",
                                  label: _vm.$t("sys.roleList.roleCN"),
                                  "min-width": "120",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "supplierNameEn",
                                  label: _vm.$t("sys.roleList.roleEN"),
                                  "min-width": "120",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "plantType",
                                  label: _vm.$t("settlementUnit.addressType"),
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "plantList." +
                                                scope.$index +
                                                ".plantType",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: { disabled: "" },
                                                model: {
                                                  value: scope.row.plantType,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "plantType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.plantType",
                                                },
                                              },
                                              [
                                                _c("el-option", {
                                                  key: "REG",
                                                  attrs: {
                                                    label: "注册地址",
                                                    value: "REG",
                                                  },
                                                }),
                                                _vm.groupType == "SUPPLIER"
                                                  ? _c("el-option", {
                                                      key: "PLANT",
                                                      attrs: {
                                                        label: "工厂地址",
                                                        value: "PLANT",
                                                      },
                                                    })
                                                  : _c("el-option", {
                                                      key: "WAREHOUSE",
                                                      attrs: {
                                                        label: "仓库",
                                                        value: "WAREHOUSE",
                                                      },
                                                    }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "tmAreaId",
                                  label: _vm.$t("supplierManage.area"),
                                  "min-width": "180",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.tmAreaId
                                          ? _c(
                                              "el-link",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.selectArea(
                                                      scope.row,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.areaName)
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "el-link",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.selectArea(
                                                      scope.row,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.countryTxt) +
                                                    _vm._s(
                                                      scope.row.provinceTxt
                                                    ) +
                                                    _vm._s(scope.row.cityTxt) +
                                                    _vm._s(
                                                      scope.row.districtTxt
                                                    )
                                                ),
                                              ]
                                            ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "address",
                                  label: _vm.$t("settlementUnit.detailAddress"),
                                  "min-width": "120",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "linkman",
                                  label: _vm.$t("settlementUnit.contacts"),
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.linkman
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  effect: "dark",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: { slot: "content" },
                                                    slot: "content",
                                                  },
                                                  _vm._l(
                                                    scope.row
                                                      .supplierContactList,
                                                    function (item, index) {
                                                      return _c(
                                                        "span",
                                                        { key: index },
                                                        [
                                                          _vm._v(
                                                            "联系人：" +
                                                              _vm._s(
                                                                item.name
                                                              ) +
                                                              "，电话：" +
                                                              _vm._s(item.tel) +
                                                              "，邮箱：" +
                                                              _vm._s(
                                                                item.email
                                                              ) +
                                                              "，办公室电话：" +
                                                              _vm._s(
                                                                item.officeTel
                                                              )
                                                          ),
                                                          _c("br"),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(scope.row.linkman)
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "telephoneNo",
                                  label: _vm.$t("settlementUnit.supplierTel"),
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.telephoneNo
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  effect: "dark",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: { slot: "content" },
                                                    slot: "content",
                                                  },
                                                  _vm._l(
                                                    scope.row
                                                      .supplierContactList,
                                                    function (item, index) {
                                                      return _c(
                                                        "span",
                                                        { key: index },
                                                        [
                                                          _vm._v(
                                                            "联系人：" +
                                                              _vm._s(
                                                                item.name
                                                              ) +
                                                              "，电话：" +
                                                              _vm._s(item.tel) +
                                                              "，邮箱：" +
                                                              _vm._s(
                                                                item.email
                                                              ) +
                                                              "，办公室电话：" +
                                                              _vm._s(
                                                                item.officeTel
                                                              )
                                                          ),
                                                          _c("br"),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.telephoneNo
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "contactOfficeTel",
                                  label: "办公室电话",
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.contactOfficeTel
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  effect: "dark",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: { slot: "content" },
                                                    slot: "content",
                                                  },
                                                  _vm._l(
                                                    scope.row
                                                      .supplierContactList,
                                                    function (item, index) {
                                                      return _c(
                                                        "span",
                                                        { key: index },
                                                        [
                                                          _vm._v(
                                                            "联系人：" +
                                                              _vm._s(
                                                                item.name
                                                              ) +
                                                              "，电话：" +
                                                              _vm._s(item.tel) +
                                                              "，邮箱：" +
                                                              _vm._s(
                                                                item.email
                                                              ) +
                                                              "，办公室电话：" +
                                                              _vm._s(
                                                                item.officeTel
                                                              )
                                                          ),
                                                          _c("br"),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.contactOfficeTel
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "emailAddress",
                                  label: _vm.$t("sys.userList.email"),
                                  "min-width": "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.emailAddress
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  effect: "dark",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: { slot: "content" },
                                                    slot: "content",
                                                  },
                                                  _vm._l(
                                                    scope.row
                                                      .supplierContactList,
                                                    function (item, index) {
                                                      return _c(
                                                        "span",
                                                        { key: index },
                                                        [
                                                          _vm._v(
                                                            "联系人：" +
                                                              _vm._s(
                                                                item.name
                                                              ) +
                                                              "，电话：" +
                                                              _vm._s(item.tel) +
                                                              "，邮箱：" +
                                                              _vm._s(
                                                                item.email
                                                              ) +
                                                              "，办公室电话：" +
                                                              _vm._s(
                                                                item.officeTel
                                                              )
                                                          ),
                                                          _c("br"),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.emailAddress
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "postCode",
                                  label: _vm.$t("settlementUnit.Postcode"),
                                  "min-width": "120",
                                },
                              }),
                              _vm.isGroup
                                ? _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      label: _vm.$t(
                                        "settlementUnit.qualificationFile"
                                      ),
                                      "min-width": "80",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.existsFile == "Y"
                                                ? _c("i", {
                                                    staticClass:
                                                      "el-icon-folder-checked iconUploadSuccess",
                                                  })
                                                : _vm._e(),
                                              _c(
                                                "el-link",
                                                {
                                                  attrs: { type: "primary" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.seeQualificationFile(
                                                        scope.row,
                                                        scope.$index
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("common.upload")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2233122551
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("common.otherAttachments"))),
                          ]),
                        ]
                      ),
                      _c(
                        "el-table",
                        {
                          staticClass: "table",
                          attrs: {
                            data: _vm.fileList,
                            border: "",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "documentName",
                              label: _vm.$t("common.file"),
                              "min-width": "130px",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-link",
                                      {
                                        attrs: { type: "primary" },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.downloadFile(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.documentName) + " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "userName",
                              label: _vm.$t("common.createBy"),
                              "min-width": "130px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "createDate",
                              label: _vm.$t("common.createDate"),
                              "min-width": "130px",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("dateFormatFilter")(
                                            scope.row.createDate,
                                            "YYYY-MM-DD HH:mm"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("common.approvalLog"), name: "2" } },
            [
              _c(
                "el-table",
                {
                  staticClass: "table",
                  attrs: {
                    data: _vm.auditLog,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "createDate",
                      label: _vm.$t("common.OperationTime"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormatFilter")(
                                  scope.row.createDate,
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "operatorName",
                      label: _vm.$t("common.OperatorName"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "action",
                      label: _vm.$t("common.PedagogicalOperation"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "comments",
                      label: _vm.$t("common.opinion"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(scope.row.comments),
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.AreaDialog, width: "400px" },
          on: {
            "update:visible": function ($event) {
              _vm.AreaDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "AreaForm",
              attrs: { model: _vm.AreaForm, "label-width": "60px" },
            },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("settlementUnit.country"),
                            prop: "country",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t("common.sel"),
                                disabled: "",
                              },
                              on: { change: _vm.countryChange },
                              model: {
                                value: _vm.AreaForm.country,
                                callback: function ($$v) {
                                  _vm.$set(_vm.AreaForm, "country", $$v)
                                },
                                expression: "AreaForm.country",
                              },
                            },
                            _vm._l(_vm.countryList, function (item) {
                              return _c("el-option", {
                                key: item.tmAreaId,
                                attrs: {
                                  clearable: "",
                                  label: item.name,
                                  value: item.tmAreaId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("settlementUnit.province"),
                            prop: "province",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t("common.sel"),
                                disabled: "",
                              },
                              on: { change: _vm.provinceChange },
                              model: {
                                value: _vm.AreaForm.province,
                                callback: function ($$v) {
                                  _vm.$set(_vm.AreaForm, "province", $$v)
                                },
                                expression: "AreaForm.province",
                              },
                            },
                            _vm._l(_vm.provinceList, function (item) {
                              return _c("el-option", {
                                key: item.tmAreaId,
                                attrs: {
                                  clearable: "",
                                  label: item.name,
                                  value: item.tmAreaId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("settlementUnit.city"),
                            prop: "city",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t("common.sel"),
                                disabled: "",
                              },
                              on: { change: _vm.cityChange },
                              model: {
                                value: _vm.AreaForm.city,
                                callback: function ($$v) {
                                  _vm.$set(_vm.AreaForm, "city", $$v)
                                },
                                expression: "AreaForm.city",
                              },
                            },
                            _vm._l(_vm.cityList, function (item) {
                              return _c("el-option", {
                                key: item.tmAreaId,
                                attrs: {
                                  clearable: "",
                                  label: item.name,
                                  value: item.tmAreaId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("DC.tmAreaId"),
                            prop: "tmAreaId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t("common.sel"),
                                disabled: "",
                              },
                              on: { change: _vm.AreaChange },
                              model: {
                                value: _vm.AreaForm.tmAreaId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.AreaForm, "tmAreaId", $$v)
                                },
                                expression: "AreaForm.tmAreaId",
                              },
                            },
                            _vm._l(_vm.AreaList, function (item) {
                              return _c("el-option", {
                                key: item.tmAreaId,
                                attrs: {
                                  clearable: "",
                                  label: item.name,
                                  value: item.tmAreaId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.AreaDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.qualificationsDialog,
            width: "50%",
            "before-close": _vm.closeQualificationsDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.qualificationsDialog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticClass: "table",
              attrs: {
                data: _vm.qualificationsList,
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "HeaderName",
                  label: _vm.$t("common.file"),
                  "max-width": "130px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "documentName",
                  label: _vm.$t("supplierManage.fileName"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.tmDocumentId
                          ? _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.downloadQualifications(scope.row)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.documentName) + " ")]
                            )
                          : _c("span", [
                              _vm._v(_vm._s(scope.row.documentName)),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.closeQualificationsDialog },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }